import React, { useState } from "react";
import ReactPlayer from 'react-player';
import iconPlay from "../../assets/Vector (1).svg";

const PublicVideoPlayer = ({ videoUrl }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    setIsPlaying(true);
  };

  return (
    <div style={styles.container}>
      {!isPlaying ? (
        <div style={styles.thumbnailContainer} onClick={handlePlay}>
          <div style={styles.aspectWrapper}>
            <ReactPlayer
              url={videoUrl}
              width="100%"
              height="100%"
              playing={false}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                objectFit: "contain",
                borderRadius: "20px",
                background: "#000"
              }}
            />
          </div>
          <div style={styles.playButtonContainer}>
            <img src={iconPlay} alt="Play button" />
          </div>
        </div>
      ) : (
        <div style={styles.aspectWrapper}>
          <video
            controls
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "20px",
              background: "#000",
              position: "absolute",
              top: 0,
              left: 0
            }}
            autoPlay
          >
            <source src={videoUrl} />
            Seu navegador não suporta a reprodução de vídeo.
          </video>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    position: "relative",
    width: "100%",
    borderRadius: "20px",
    overflow: "hidden",
  },
  thumbnailContainer: {
    position: "relative",
    cursor: "pointer",
    overflow: "hidden",
  },
  aspectWrapper: {
    width: "100%",
    aspectRatio: "16/9",
    borderRadius: "20px",
    overflow: "hidden",
    background: "#000",
    position: "relative"
  },
  playButtonContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    cursor: "pointer",
    zIndex: 2
  },
};

export default PublicVideoPlayer;

